

























































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ResizeUpdateMixin from '@/common/ts/resizing/ResizeUpdateMixin';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';
import i18n from '@/webcomponents/editorial-highlight/i18n';
import VideoPauseHandler from '@/common/ts/pausing-videos/VideoPauseHandler';
import IntersectionDirective from '../../common/vue/intersection-directive';

const WordFade = () => import('@/common/vue/WordFade.vue');
const ResponsiveImage = () => import('@/common/vue/ResponsiveImage.vue');
const RelaunchButton = () => import('@/common/vue/RelaunchButton.vue');
const Co2Labeling = () => import('@/webcomponents/co2-labeling/Co2Labeling.vue');

const EditorialHighlightProps = Vue.extend({
  props: {
    headlineText: String,
    overlineText: String,
    copyText: String,
    pictureJson: String,
    aspectRatio: {
      type: String,
      default: '16by9',
    },
    backgroundColor: {
      type: String,
      default: 'white',
    },
    desktopVideo: String,
    tabletVideo: String,
    mobileVideo: String,
    linkText: String,
    externalLink: String,
    internalLink: String,
    linkTarget: String,
    buttonLink: String,
    buttonExternalLink: String,
    buttonInternalLink: String,
    buttonLinkTarget: String,
    modelName: String,
    labelingJson: String,
    editMode: Boolean,
  },
});

@Component({
  components: {
    WordFade,
    ResponsiveImage,
    RelaunchButton,
    Co2Labeling,
  },
  directives: {
    intersect: IntersectionDirective,
  },
  i18n,
})
export default class EditorialHighlight extends mixins(EditorialHighlightProps, ResizeUpdateMixin) {
  $refs!: {
    video: HTMLVideoElement;
  }

  showMedia = false;
  showHeadline = false;
  showBottomText = false;
  showOverline = false;
  observerOptions = {
    rootMargin: '0px',
  }

  get rootClass () {
    return {
      'brandhub-editorial-highlight--show': this.showMedia,
      'brandhub-editorial-highlight--media-3by4': this.aspectRatio === '3by4',
      'brandhub-editorial-highlight--background-black': this.backgroundColor === 'black',
    };
  }

  get hasLinks () {
    return this.externalLink || this.internalLink || this.buttonExternalLink || this.buttonInternalLink;
  }

  get videoSource () {
    if (this.mobileVideo && this.isMobile) {
      return this.mobileVideo;
    }
    if (this.tabletVideo && this.isTablet) {
      return this.tabletVideo;
    }
    if (this.desktopVideo) {
      return this.desktopVideo;
    }
    return '';
  }

  get buttonTheme () {
    return this.backgroundColor === 'black' ? 'dark' : 'light';
  }

  get overlineClass () {
    return {
      'brandhub-editorial-highlight__overline--in': this.showOverline,
    };
  }

  get bottomContainerClass () {
    return {
      'brandhub-editorial-highlight__bottom-container--in': this.showBottomText,
    };
  }

  handleIntersection (isIntersecting: boolean) {
    if (isIntersecting) {
      this.showMedia = true;
      setTimeout(() => {
        this.showHeadline = true;
      }, 850);
      setTimeout(() => {
        this.showBottomText = true;
        this.showOverline = true;
      }, 1250);
    }
  }

  updateVideoPauseHandler () {
    if (this.$refs.video) {
      VideoPauseHandler.getInstance().addNewVideo(this.$refs.video);
    }
  }

  onTextLinkClick () {
    if (this.linkText) {
      const link = this.externalLink ? this.externalLink : this.internalLink;
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Editorial Highlight', this.linkText, link);
    }
  }

  onButtonClick () {
    if (this.buttonLink) {
      const link = this.buttonExternalLink ? this.buttonExternalLink : this.buttonInternalLink;
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Editorial Highlight', this.buttonLink, link);
    }
  }

  created () {
    this.$on('resizeEnd', this.updateVideoPauseHandler);
  }

  mounted () {
    VideoPauseHandler.getInstance().addNewVideo(this.$refs.video as HTMLVideoElement);
  }
}
